import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function GamingLicensePanama (){

    return (
        <main className='main'>

            <IntroSection
                title="Gaming License – Panama"
                subtitle="Operate Land-Based & Online Gaming in Latin America"
                description =
                    "
                    <b>Panama</b> is a <b>regulated gaming jurisdiction</b> in <b>Latin America</b>, offering <b>licenses for casinos, sportsbooks, slot operators, and online betting platforms</b>. The industry is overseen by the <b>Junta de Control de Juegos (JCJ)</b> under the <b>Ministry of Economy and Finance</b>.
                    <br/>
                    With its <b>territorial tax system</b>, <b>strong tourism industry</b>, and <b>growing digital adoption</b>, <b>Panama</b> provides a <b>solid gateway</b> for <b>LatAm-facing gaming businesses</b>.

                    "
                badges={
                [
                    "Land-Based Casinos",
                    "Slot Machine Operators",
                    "Sportsbooks",
                    "Online Betting Platforms"
                ]
                }
                buttonText="Request a Panama Gaming Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/gaming-igaming-license-malta-hero-image.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title=' Why Choose Panama for Gaming?'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "Latin American Recognition", text: "regulated, not a grey-market license" },
                                        { title: "Government Oversight", text: "JCJ supervision ensures credibility" },
                                        { title: "Flexible Structures", text: "land-based + online betting options" },
                                        { title: "Tax-Friendly", text: "territorial system (foreign income not taxed)" },
                                        { title: "Tourism Boost", text: "Panama casinos attract international visitors" }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Gaming Licenses in Panama"
                        blocks={[
                            {
                                title: "Casino License",
                                items:
                                    [
                                        { title: "Land-Based Casinos", text: "For land-based casinos" },
                                        { title: "Scope", text: "Covers table games, slot machines, and electronic gaming" },
                                        { title: "Associated Developments", text: "Often linked with hotel/tourism developments" }
                                    ]
                            },
                            {
                                title: "Slot Machine / Electronic Gaming License",
                                items: [
                                    { title: "Specific license for slot halls and gaming machines"},
                                    { title: "Must comply with JCJ’s technical and compliance rules"},
                                ]
                            },
                            {
                                title: "Sports Betting License",
                                items:
                                    [
                                        { text: "Covers retail sportsbooks and betting shops" },
                                        { text: "Online betting permitted with regulatory approval" },
                                        { text: "Capital & technical requirements apply" }
                                    ]
                            },
                            {
                                title: "Online Gambling License (Limited)",
                                items:
                                    [
                                        { text: "Panama does issue online betting licenses, but not as globally recognized as Malta or Curacao" },
                                        { text: "Best for LatAm-facing operators targeting regional players" }
                                    ]
                            }
                        ]}
                    />


                    <FeatureCards
                        title='Capital & Requirements'
                        features={
                            [
                                { title: "Casino Operators", text: "USD 2,000,000+ investment required" },
                                { title: "Sportsbooks", text: "Minimum USD 250,000 capital" },
                                { title: "Online Betting", text: "Compliance with JCJ rules + local incorporation" },
                                { title: "Guarantees", text: "Bank guarantees may be required depending on license" }
                            ]
                        }
                    />

                    <LocationTimeline
                        title='Benefits of a Panama Gaming License'
                        item={
                            [
                                { title: "Legitimate & Regulated", text: "licensed by JCJ, backed by government" },
                                { title: "Covers Land & Online", text: "flexibility for operators" },
                                { title: "Banking Access", text: "better than unregulated offshore licenses" },
                                { title: "Regional Expansion", text: "strong base for LatAm-focused operators" },
                                { title: "Tourism-Driven Casinos", text: "synergy with Panama’s hotel sector" }
                            ]
                        }
                    />

                    {/* Services */}
                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                { title: "Pre-Application Consultation", text: "choose casino, sportsbook, or online betting" },
                                { title: "Company Incorporation", text: "establish Panama entity" },
                                { title: "Application Submission", text: "business plan, AML/KYC policies, compliance docs" },
                                { title: "JCJ Review", text: "regulator evaluates financials, directors, and technical setup" },
                                { title: "Approval & Licensing", text: "usually 6–9 months" }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–9 months",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 100,000+ (legal, compliance, application)",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Capital Requirement",
                                description: "USD 250k–2M depending on license",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                            {
                                name: "Annual Costs",
                                description: "supervision, audits, JCJ fees",
                                background: "#EFF6FF",
                                border: "#DBEAFE"
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {text: "Specialists in LatAm gaming licensing",},
                                {text: "End-to-end support: incorporation, license filing, compliance manuals"},
                                {text: "Partnerships with gaming software providers, PSPs, and hosting platforms"},
                                {text: "Comparison: Panama vs Curacao vs Malta vs Western Sahara"},
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title='Looking to launch a licensed casino, sportsbook, or betting platform in Latin America?'
                         description=
                             "
                             <b>Panama</b> offers <b>casino, sportsbook, and online betting licenses</b> regulated by the <b>JCJ</b>, with <b>tax benefits</b> and <b>regional credibility</b>.
                             "
                         buttonText='Book a Panama Gaming License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can I operate an online casino with a Panama license?",
        content: [
            { type: "answer", text: "Yes, but Panama’s recognition is mostly regional (LatAm), not as global as Malta or Curacao." },
        ],
    },
    {
        question: "What’s the capital requirement for sportsbooks?",
        content: [
            { type: "answer", text: "At least USD 250,000, plus compliance reserves." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Around 6–9 months." },
        ],
    },
    {
        question: "Is Panama better than Curacao for online gaming?",
        content: [
            { type: "answer", text: "Curacao is more recognized globally; Panama is better for LatAm + local credibility." },
        ],
    },
    {
        question: "Can Panama casinos serve tourists?",
        content: [
            { type: "answer", text: "Yes — many casinos are integrated with hotels and resorts." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We secured a Panama sportsbook license. Offshore Advisory made the JCJ process clear and compliant.",
            author: "Ricardo P.",
            role: "Sportsbook Operator"
        },
        {
            quote: "Panama was the right choice for our land-based casino investment. Offshore Advisory handled the licensing smoothly.",
            author: "Sofia G.",
            role: "Casino Investor"
        }
    ]
;